import {SearchOutlined} from "@mui/icons-material";
import {ChangeEvent, useEffect, useState} from "react";
import InputGroup from "./FormComponents/InputGroup";
import IconButtonPop from "./IconButtonPop";


type Params = {
    placeholder: string,
    onSearch: (query:string) => void
}

export function SearchBox({placeholder, onSearch}:Params) {
    const [query, setQuery] = useState<string>();
    const [focussed, setFocussed] = useState(false);

    useEffect(() => {
        if (query === "") {
            onSearch("");
        }
    }, [query]);

    return (
        <form onSubmit={(e) => {
            e.preventDefault(); onSearch(query || "");
        }} style={{marginRight: "7px"}}>
            <div style={{position: "relative"}} onFocus={() => setFocussed(true)} onBlur={() => query || setFocussed(false)}>
                <InputGroup sx={{width: focussed ? "150px" : "40px", opacity: focussed ? 1 : 0, transition: "all ease-in-out 250ms"}} {...{placeholder}} value={query} onChange={(e:ChangeEvent<HTMLInputElement>) => setQuery(e.target.value)}/>
                <IconButtonPop responsive={false} onClick={() => query && onSearch(query)} sx={{position: "absolute", zIndex: 9, right: "0", top: "50%", transform: "translateY(-50%)"}} title={"Search"}><SearchOutlined/></IconButtonPop>
            </div>
        </form>
    );
}
